module.exports = __webpack_public_path__ + "img/referral_3.40c5a7fe.jpeg";